import { render, staticRenderFns } from "./MenuRouteItem.vue?vue&type=template&id=3121ebee&scoped=true"
import script from "./MenuRouteItem.vue?vue&type=script&lang=js"
export * from "./MenuRouteItem.vue?vue&type=script&lang=js"
import style0 from "./MenuRouteItem.vue?vue&type=style&index=0&id=3121ebee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3121ebee",
  null
  
)

export default component.exports